import { render, staticRenderFns } from "./LbaMenuTree.vue?vue&type=template&id=0bb6e8d7"
import script from "./LbaMenuTree.vue?vue&type=script&lang=js"
export * from "./LbaMenuTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports